var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVoiceOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.452,
    height: 20.452
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6366",
    fill: "none",
    d: "M0 0h20.452v20.452H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11374",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26733",
    d: "M8.35 5.199V4.044a2.074 2.074 0 014.148 0v5.345",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26734",
    d: "M13.736 14.128a5.3 5.3 0 01-8.66-4.115",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26735",
    d: "M15.702 10.013a5.278 5.278 0 01-.313 1.792",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1037",
    strokeLinejoin: "round",
    d: "M10.39 15.324v3.203"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1038",
    d: "M1.943 2.375l16.439 16.439"
  }))));
}
export default SvgIcVoiceOff;